import { I18nValues } from './types';

export const localI18nEn: I18nValues = {
	'general.genericError.title': '<b>We apologize</b>, but we are currently unable to fulfill your request.',
	'general.genericError.subtitle': 'Please try again later',
	'general.back': 'Back',
};
